import type { SVGProps } from 'react';
const SvgNetworkWifi = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#network_wifi_svg__a)">
      <path
        fill="currentColor"
        d="M24 8.98A16.88 16.88 0 0 0 12 4C7.31 4 3.07 5.9 0 8.98L12 21 24 8.98Zm-21.08.09C5.51 7.08 8.67 6 12 6s6.49 1.08 9.08 3.07l-1.43 1.43A12.99 12.99 0 0 0 12 8c-2.86 0-5.5.94-7.65 2.51L2.92 9.07Z"
      />
    </g>
    <defs>
      <clipPath id="network_wifi_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgNetworkWifi;
